import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDListInternal = {
  namespaced: true,

  state: {
    name: 'dListInternal',
    dListInternal: []
  },

  mutations,
  getters,
  actions
}

export default moduleDListInternal;